import React from 'react'

export const navLinks = [
  { id: "1", name: "Dashboard", to: "/home", icon: <i className="fa fa-home" /> },
  { id: "2", name: "Accounts", to: "/accounts", icon: <i className="fa fa-user-plus" /> },
  { id: "8", name: "Invoices", to: "/invoices", icon: <i className="fa fa-file-text-o" /> },
  { id: "3", name: "Payments", to: "/payments", icon: <i className="fa fa-credit-card" /> },
  { id: "7", name: "Bonuses", to: "/bonuses", icon: <i className="fa fa-gift" /> },
  { id: "4", name: "Tickets", to: "/tickets", icon: <i className="fa fa-question-circle" />},
  // { id: "5", name: "Settings", to: "/settings", icon: <i className="fa fa-sliders" /> },
  { id: "6", name: "Logout", to: "/logout", icon: <i className="fa fa-sign-out" /> },
];

/**
 * Build a breadcrumb trail for a detail page.
 * @param {{ listLabel: string, listTo: string, recordLabel?: string }} opts
 */
export function getDetailBreadcrumbTrail({ listLabel, listTo, recordLabel } = {}) {
  if (!listLabel || !listTo) return [];
  const crumbs = [
    { label: 'Home', to: '/home' },
    { label: listLabel, to: listTo },
  ];
  if (recordLabel) {
    crumbs.push({ label: String(recordLabel), to: null });
  }
  return crumbs;
}